import { palette } from "./ns-color-palette";
import { NsSpacingDefault, NsTheme, NsTypographyDefault } from "./ns-eds-types";

export const light: NsTheme = {
  name: "light",
  colors: {
    content: palette.gray800,
    contentEmphasis: palette.blue700,
    contentSubtle: palette.alphaBlack500,
    contentPlaceholder: palette.alphaBlack500,
    contentInverse: palette.white,
    contentInteractive: palette.blue500,
    contentInteractiveHover: palette.blue600,
    contentInteractivePressed: palette.blue700,
    contentInteractiveInverse: palette.white,
    contentSelected: palette.blue500,
    contentInfo: palette.blue500,
    contentSuccess: palette.green500,
    contentWarning: palette.orange500,
    contentError: palette.red600,
    contentDestructive: palette.red600,
    contentDestructiveHover: palette.red700,
    contentDestructivePressed: palette.red800,
    contentOnAccentSubtle: palette.alphaBlack600,
    contentOnAccentYellow: palette.alphaBlack600,
    contentLogo: palette.blue700,

    background: palette.white,
    backgroundElevated1: palette.white,
    backgroundElevated2: palette.white,
    backgroundElevated3: palette.white,
    backgroundSunken: palette.gray50,
    backgroundEmphasisPrimary: palette.blue50,
    backgroundEmphasisSecondary: palette.gray50,
    backgroundBrandPrimary: palette.yellow500,
    backgroundBrandSecondary: palette.blue700,
    backgroundHover: palette.alphaBlack50,
    backgroundPressed: palette.alphaBlack100,
    backgroundSelected: palette.blue100,
    backgroundSelectedHover: palette.blue200,
    backgroundSelectedPressed: palette.blue300,
    backgroundSelectedOnBrandPrimary: palette.blue500,
    backgroundInteractive: palette.blue500,
    backgroundInteractiveHover: palette.blue600,
    backgroundInteractivePressed: palette.blue700,
    backgroundInput: palette.white,
    backgroundDiscovery: palette.green600,
    backgroundAlpha: palette.alphaBlack300,
    backgroundAlphaSubtle: palette.alphaBlack75,
    backgroundInverse: palette.gray700,
    backgroundOverlay: palette.alphaBlack500,
    backgroundInfoSubtle: palette.blue50,
    backgroundInfo: palette.blue500,
    backgroundInfoHover: palette.blue600,
    backgroundInfoPressed: palette.blue700,
    backgroundSuccessSubtle: palette.green50,
    backgroundSuccess: palette.green500,
    backgroundSuccessHover: palette.green600,
    backgroundSuccessPressed: palette.green700,
    backgroundWarningSubtle: palette.orange50,
    backgroundWarning: palette.orange500,
    backgroundWarningHover: palette.orange600,
    backgroundWarningPressed: palette.orange700,
    backgroundErrorSubtle: palette.red50,
    backgroundError: palette.red600,
    backgroundErrorHover: palette.red700,
    backgroundErrorPressed: palette.red800,
    backgroundDestructive: palette.red600,
    backgroundDestructiveHover: palette.red700,
    backgroundDestructivePressed: palette.red800,
    backgroundAccentGraySubtle: palette.alphaBlack100,
    backgroundAccentGray: palette.alphaBlack500,
    backgroundAccentBlueSubtle: palette.blue100,
    backgroundAccentBlue: palette.blue500,
    backgroundAccentGreenSubtle: palette.green100,
    backgroundAccentGreen: palette.green600,
    backgroundAccentOrangeSubtle: palette.orange100,
    backgroundAccentOrange: palette.orange500,
    backgroundAccentRedSubtle: palette.red100,
    backgroundAccentRed: palette.red500,
    backgroundAccentYellowSubtle: palette.yellow100,
    backgroundAccentYellow: palette.yellow500,
    backgroundAccentPurpleSubtle: palette.purple100,
    backgroundAccentPurple: palette.purple500,
    backgroundAccentPinkSubtle: palette.pink100,
    backgroundAccentPink: palette.pink500,

    border: palette.alphaBlack100,
    borderSubtle: palette.alphaBlack75,
    borderEmphasis: palette.alphaBlack300,
    borderInverse: palette.white,
    borderInteractive: palette.blue500,
    borderInteractiveHover: palette.blue600,
    borderInteractivePressed: palette.blue700,
    borderInput: palette.gray300,
    borderInputHover: palette.gray400,
    borderInfo: palette.blue500,
    borderSuccess: palette.green500,
    borderWarning: palette.orange500,
    borderError: palette.red600,
    borderDestructive: palette.red600,
    borderDestructiveHover: palette.red700,
    borderDestructivePressed: palette.red800,
    borderLogo: palette.transparent,
    borderSelected: palette.blue500,
    borderSelectedOnBrandPrimary: palette.blue500,
    borderFocus: palette.blue500,
  },
  spacing: NsSpacingDefault,
  typography: NsTypographyDefault,
  boxShadow: `  box-shadow: 0px 1px 4px 0px #00000014;
  box-shadow: 0px 1px 2px 0px #00000014;`,
};
